import { useState, useCallback } from "react";
import { processMedicalClaimWithIA } from "Requests/IA/processMedicalClaim";
import { createToast } from "Utils/toastFunc";
import { IAResponse } from "../interface";

export const useIAState = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [iaResponse, setIaResponse] = useState<IAResponse | null>(null);
  const [error, setError] = useState<string | null>(null);

  const generateWithIA = useCallback(async (fileBlobs: Blob[]) => {
    setIsProcessing(true);
    setError(null);

    try {
      // Chamada real para API com Blobs
      let response = await processMedicalClaimWithIA(fileBlobs);

      if (!response.matching_results.resultados.length) {
        throw new Error("Nenhum produto foi encontrado ao processar com IA.");
      }

      response = {
        ...response,
        matching_results: {
          ...response.matching_results,
          resultados: response.matching_results.resultados.map(
            (resultado: any) => ({
              ...resultado,
              id: resultado.id === 280 ? 944 : resultado.id || null,
              nome_encontrado:
                resultado.id === 280
                  ? "Glicose - Domiciliar"
                  : resultado.nome_encontrado || null,
            })
          ),
        },
      };

      setIaResponse(response);
    } catch (err: any) {
      createToast("error", err.message);
      setError("Erro ao processar com IA. Tente novamente.");
    } finally {
      setIsProcessing(false);
    }
  }, []);

  const clearIAState = useCallback(() => {
    setIaResponse(null);
    setError(null);
  }, []);

  // Extrair IDs dos produtos encontrados pela IA
  const getProductIdsFromIA = useCallback(() => {
    if (!iaResponse) return [];

    return iaResponse.matching_results.resultados
      .filter((result: any) => result.encontrado && result.id)
      .map((result: any) => result.id!)
      .filter(
        (id: any, index: number, arr: any[]) => arr.indexOf(id) === index
      ); // Remove duplicatas
  }, [iaResponse]);

  return {
    isProcessing,
    iaResponse,
    error,
    generateWithIA,
    clearIAState,
    getProductIdsFromIA,
  };
};
